import { renderSlot as _renderSlot } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.mounted ? _renderSlot(_ctx.$slots, "placeholder", {
    key: 0
  }) : _renderSlot(_ctx.$slots, "default", {
    key: 1
  });
}